import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/companies/new")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/companies/new", search, replace: true });
    },
});
